import { Entity, FieldType } from 'gossamer-unified';
import { TaskDefinition } from 'gossamer-model';
import { UserView } from 'cb-model';

export interface WorkflowInitiationRow {
  task_definition_id: number;
  assigned_to: string;
}

export const WorkflowInitiation: Entity<WorkflowInitiationRow> = {
  id: 'WorkflowInitiation',
  title: 'Workflow Initiation',
  primaryKeyFields: [],
  security: [{ role: 'staff', action: 'create', access: 'all' }],
  fields: {
    task_definition_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'Task Definition',
      mandatory: true,
      refEntity: TaskDefinition,
      refFilters: [
        {
          fieldId: 'type',
          operator: 'eq',
          value: 'ROOT',
        },
      ],
    },
    assigned_to: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Assigned User',
      mandatory: true,
      refEntity: UserView,
    },
  },
};
